import { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import ShareIcon from "../../assets/ShareIcon";
import Toast from "../../services/ToastMessage";
interface VideoPlayerProps {
  id: string;
  videoURL: string;
  playingVideoId: string | null;
  onVideoPlay: (isPlaying: string | null) => any;
  onVideoPause?: () => any;
  onVideoEnd?: (isPlaying: string | null) => any;
}

const isYouTubeURL = (url: string): boolean =>
  url.includes("youtube.com") || url.includes("youtu.be");

const VideoPlayer: React.FC<VideoPlayerProps> = ({
  id,
  videoURL,
  playingVideoId,
  onVideoPlay,
  onVideoPause,
  onVideoEnd,
}) => {
  const playerRef = useRef<ReactPlayer>(null);
  const isYT = isYouTubeURL(videoURL);

  // Non-YT custom controls state
  const [playing, setPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const [volume, setVolume] = useState(1);
  const [muted, setMuted] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [showPlaybackMenu, setShowPlaybackMenu] = useState(false);
  const [playbackRate, setPlaybackRate] = useState(1); // Default speed
  const speeds = [0.5, 1, 1.25, 1.5, 1.75, 2];
  const [isLoaded, setIsLoaded] = useState(false);


const [showShareMenu, setShowShareMenu] = useState(false);
const [copied, setCopied] = useState(false);



const handleCopy = async () => {
  await navigator.clipboard.writeText(videoURL);
  setCopied(true);
  Toast({
    type: "success",
    message: "Link has been copied !",
  });
  setTimeout(() => setCopied(false), 2000);
};

const handleCopyIcon = async (videoURL:string) => {
  console.log("video URL***", videoURL)
  await navigator.clipboard.writeText(videoURL);

  Toast({
    type: "success",
    message: "Link has been copied !",
  });
};

const shareOptions = [
  {
    label: "Copy Link",
    icon: (
      <svg width="24" height="24" viewBox="0 0 16 16" fill="none">
        <path d="M7.05025 1.53553C8.03344 0.552348 9.36692 0 10.7574 0C13.6528 0 16 2.34721 16 5.24264C16 6.63308 15.4477 7.96656 14.4645 8.94975L12.4142 11L11 9.58579L13.0503 7.53553C13.6584 6.92742 14 6.10264 14 5.24264C14 3.45178 12.5482 2 10.7574 2C9.89736 2 9.07258 2.34163 8.46447 2.94975L6.41421 5L5 3.58579L7.05025 1.53553Z" fill="#001e5a"/>
        <path d="M7.53553 13.0503L9.58579 11L11 12.4142L8.94975 14.4645C7.96656 15.4477 6.63308 16 5.24264 16C2.34721 16 0 13.6528 0 10.7574C0 9.36693 0.552347 8.03344 1.53553 7.05025L3.58579 5L5 6.41421L2.94975 8.46447C2.34163 9.07258 2 9.89736 2 10.7574C2 12.5482 3.45178 14 5.24264 14C6.10264 14 6.92742 13.6584 7.53553 13.0503Z" fill="#001e5a"/>
        <path d="M5.70711 11.7071L11.7071 5.70711L10.2929 4.29289L4.29289 10.2929L5.70711 11.7071Z" fill="#001e5a"/>
      </svg>
    ),
    onClick: handleCopy,
    label2: copied ? "Copied!" : "Copy Link",
  },
  {
    label: "WhatsApp",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="#25D366">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
      </svg>
    ),
    onClick: () => window.open(`https://wa.me/?text=${encodeURIComponent(videoURL)}`, "_blank"),
  },
  {
    label: "Email",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="#001e5a">
        <path d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
      </svg>
    ),
    onClick: () => {
  const subject = "Check this video";
  const body = encodeURIComponent(videoURL);
  window.location.href = `mailto:?subject=${subject}&body=${body}`;
}
  },
];

  const wrapperRef = useRef<HTMLDivElement>(null);

  const handleContextMenu = (e: React.MouseEvent) => {
    e.preventDefault();
    return false;
  };

  const formatTime = (seconds: number): string => {
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return `${m}:${s.toString().padStart(2, "0")}`;
  };

  // Sync external playingVideoId with local state for non-YT
  useEffect(() => {
    if (!isYT) {
      setPlaying(playingVideoId === id);
    }
  }, [playingVideoId, id, isYT]);

  

  // ─── YouTube Player ──────────────────────────────────────────
  if (isYT) {
    return (
      <div className="player-wrapper" onContextMenu={handleContextMenu}
        style={{ position: "relative" }}>
        <ReactPlayer
        onReady={() => setIsLoaded(true)} // Set to true when video is ready
        onStart={() => setIsLoaded(true)} // Optional: double-check on start
          controls
          className="react-player"
          width="100%"
          height="100%"
          url={videoURL}
          playing={playingVideoId && id == playingVideoId ? true : false}
          onPlay={() => onVideoPlay(id)}
          onPause={() => {
            playingVideoId && id == playingVideoId && onVideoPlay(null);
            onVideoPause?.();
          }}
          onEnded={() => onVideoEnd?.(id)}
          config={{
            youtube: {
              playerVars: { rel: 0, modestbranding: 1 },
            },
          }}
        />
        {
          isLoaded &&
          <div style={{
            position: "absolute",
            bottom: 8,
            left: 16,
            display: "flex",
            alignItems: "center",
            gap: "16px",
            background: "rgba(255,255,255,0.85)",
            backdropFilter: "blur(4px)",
            borderRadius: "50px",        // pill shape
            padding: "12px 24px",
            zIndex: 10,
            // pointerEvents: "none",
            pointerEvents: "all"
          }}>
          {/* Share Arrow */}
          <div onClick={() => setShowShareMenu(!showShareMenu)} style={{pointerEvents: "all", cursor: "pointer"}}>
            <ShareIcon width={28} height={28} color="#001e5a" />
          </div>

          {/* Copy Link */}
          <svg onClick={()=> handleCopyIcon(videoURL)} style={{cursor: "pointer"}} width="28" height="28" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7.05025 1.53553C8.03344 0.552348 9.36692 0 10.7574 0C13.6528 0 16 2.34721 16 5.24264C16 6.63308 15.4477 7.96656 14.4645 8.94975L12.4142 11L11 9.58579L13.0503 7.53553C13.6584 6.92742 14 6.10264 14 5.24264C14 3.45178 12.5482 2 10.7574 2C9.89736 2 9.07258 2.34163 8.46447 2.94975L6.41421 5L5 3.58579L7.05025 1.53553Z" fill="#001e5a"/>
            <path d="M7.53553 13.0503L9.58579 11L11 12.4142L8.94975 14.4645C7.96656 15.4477 6.63308 16 5.24264 16C2.34721 16 0 13.6528 0 10.7574C0 9.36693 0.552347 8.03344 1.53553 7.05025L3.58579 5L5 6.41421L2.94975 8.46447C2.34163 9.07258 2 9.89736 2 10.7574C2 12.5482 3.45178 14 5.24264 14C6.10264 14 6.92742 13.6584 7.53553 13.0503Z" fill="#001e5a"/>
            <path d="M5.70711 11.7071L11.7071 5.70711L10.2929 4.29289L4.29289 10.2929L5.70711 11.7071Z" fill="#001e5a"/>
          </svg>
          </div>
        }
        {/* Share Menu Popup */}
        {showShareMenu && (
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "absolute",
              bottom: "80px",
              left: "16px",
              background: "rgba(255,255,255,0.95)",
              backdropFilter: "blur(8px)",
              borderRadius: "16px",
              padding: "8px 0",
              zIndex: 20,
              minWidth: "220px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
            }}
          >
            {/* Header */}
            <div style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px 20px 12px",
              borderBottom: "1px solid rgba(0,0,0,0.1)",
            }}>
              <span style={{ fontWeight: 600, fontSize: "16px", color: "#001e5a" }}>
                Share via...
              </span>
              <button
                onClick={() => setShowShareMenu(false)}
                style={{ background: "none", border: "none", cursor: "pointer", fontSize: "18px", color: "#666" }}
              >
                ✕
              </button>
            </div>

            {/* Options */}
            {shareOptions.map((option, i) => (
              <button
                key={i}
                onClick={() => { option.onClick(); setShowShareMenu(false); }}
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  gap: "16px",
                  padding: "14px 20px",
                  background: "none",
                  border: "none",
                  borderBottom: i < shareOptions.length - 1 ? "1px solid rgba(0,0,0,0.07)" : "none",
                  cursor: "pointer",
                  fontSize: "15px",
                  color: "#001e5a",
                  fontWeight: 500,
                  textAlign: "left",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "rgba(0,30,90,0.05)")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "none")}
              >
                {option.icon}
                {option.label2 ?? option.label}
              </button>
            ))}
          </div>
        )}
      </div>
    );
  }

  // ─── Non-YouTube Player (custom controls) ────────────────────
  return (
    <div className="player-wrapper" onContextMenu={handleContextMenu}>
      {/* <div>{playingVideoId}</div> */}
      <ReactPlayer
        controls
        className="react-player"
        width="100%"
        height="100%"
        url={videoURL}
        playing={playingVideoId && id == playingVideoId ? true : false}
        onPlay={() => {
          onVideoPlay(id);
        }}
        onPause={() => {
          playingVideoId && id == playingVideoId && onVideoPlay(null);
          onVideoPause?.();
        }}
        onEnded={() => {
          onVideoEnd?.(id);
        }}
        config={{
          file: {
            attributes: {
              controlsList: "nodownload", // Disable download & playback speed
              onContextMenu: (e: MouseEvent) => e.preventDefault(),
            },
          },
        }}
      />
    </div>
  );
};

// Shared button style
const btnStyle: React.CSSProperties = {
  color: "#fff",
  background: "none",
  border: "none",
  cursor: "pointer",
  fontSize: "16px",
  padding: "2px 4px",
  display: "flex",
  alignItems: "center",
};

export default VideoPlayer;